export default "__VITE_ASSET__8ff4dbea__"